const TEST_BASE_URL = 'https://test-api.ttvan56.com'
const PROD_BASE_URL = 'https://api.ttvan56.com'

const buildDevBaseUrl = () => {
	if (typeof window !== 'undefined' && window.location?.origin) {
		return window.location.origin
	}

	return ''
}

let BaseUrl = buildDevBaseUrl()

if (process.env.NODE_ENV === 'production') {
	BaseUrl = process.env.VUE_APP_ENV === 'test' ? TEST_BASE_URL : PROD_BASE_URL
}

export { BaseUrl }
